import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-service-description',
  templateUrl: './offline-service-description.component.html',
  styleUrls: ['./offline-service-description.component.scss']
})
export class OfflineServiceDescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
